import { TIME_SINCE, TIME_UNTIL } from 'customer-data-objects/property/DateDisplayHint';
export const isRelativeTimeProperty = field => {
  return (field === null || field === void 0 ? void 0 : field.dateDisplayHint) === TIME_SINCE || (field === null || field === void 0 ? void 0 : field.dateDisplayHint) === TIME_UNTIL;
};
export const isRelativeTimePropertyReferenceRecord = referenceRecord => {
  const dateDisplayHint = referenceRecord.get('dateDisplayHint');
  return dateDisplayHint === TIME_SINCE || dateDisplayHint === TIME_UNTIL;
};